import { WIX_BLOG, WIX_BOOKINGS, WIX_CHALLENGES, WIX_EVENTS, WIX_GROUPS, WIX_PORTFOLIO, WIX_NEW_STORES, WIX_RESTAURANTS_MENUS_NEW, PRICING_PLANS, WIX_RESTAURANTS_TABLE_RESERVATIONS } from '@wix/app-definition-ids';
import { ITEM_TYPES } from '@wix/seo-types';
export const supportedItemTypes = [ITEM_TYPES.STATIC_PAGE_V2, ITEM_TYPES.STORES_PRODUCT, ITEM_TYPES.STORES_CATEGORY, ITEM_TYPES.BOOKINGS_SERVICE, ITEM_TYPES.BLOG_POST, ITEM_TYPES.EVENTS_PAGE, ITEM_TYPES.PORTFOLIO_PROJECTS, ITEM_TYPES.PORTFOLIO_COLLECTIONS, ITEM_TYPES.GROUPS_PAGE, ITEM_TYPES.CHALLENGES_PAGE, ITEM_TYPES.RESTAURANTS_MENU_PAGE, ITEM_TYPES.PRICING_PLANS, ITEM_TYPES.TABLE_RESERVATIONS_EXPERIENCE];

// Additional page types that won't show notifications in the Editor 3 wizard.
export const notificationExcludedTpaPageIds = ['Challenges', 'thank_you_page', 'shopping_cart', 'blog', 'Portfolio', 'Event List', 'bookings_list', 'Booking Calendar'];
const DEFAULT_PAGE_LIMIT = 300;
const itemTypeConfigMap = {
  [ITEM_TYPES.STATIC_PAGE_V2]: {
    itemType: ITEM_TYPES.STATIC_PAGE_V2,
    appDefId: ITEM_TYPES.STATIC_PAGE_V2,
    // TODO: should be undefined?
    siteStructureFilter: {
      itemTypeIdentifier: 'static_page'
    }
  },
  [ITEM_TYPES.STORES_PRODUCT]: {
    itemType: ITEM_TYPES.STORES_PRODUCT,
    appDefId: WIX_NEW_STORES,
    templatePageIntentId: 'product_page',
    siteStructureFilter: {
      itemTypeIdentifier: 'wix.stores.sub_pages.product',
      sourceId: '1380b703-ce81-ff05-f115-39571d94dfcd'
    },
    pageLimit: DEFAULT_PAGE_LIMIT,
    excludedPageIntentIds: ['ecom_side_cart', 'Category Page', 'checkout']
  },
  [ITEM_TYPES.STORES_CATEGORY]: {
    itemType: ITEM_TYPES.STORES_CATEGORY,
    appDefId: WIX_NEW_STORES,
    templatePageIntentId: 'Category Page',
    siteStructureFilter: {
      itemTypeIdentifier: 'wix.stores.sub_pages.category',
      sourceId: '1380b703-ce81-ff05-f115-39571d94dfcd'
    },
    pageLimit: DEFAULT_PAGE_LIMIT
  },
  [ITEM_TYPES.BOOKINGS_SERVICE]: {
    itemType: ITEM_TYPES.BOOKINGS_SERVICE,
    appDefId: WIX_BOOKINGS,
    templatePageIntentId: 'Booking Service Page',
    siteStructureFilter: {
      itemTypeIdentifier: 'wix.bookings.sub_pages.service_page',
      sourceId: '13d21c63-b5ec-5912-8397-c3a5ddb27a97'
    },
    excludedPageIntentIds: [],
    pageLimit: DEFAULT_PAGE_LIMIT
  },
  [ITEM_TYPES.BLOG_POST]: {
    itemType: ITEM_TYPES.BLOG_POST,
    appDefId: WIX_BLOG,
    templatePageIntentId: 'post',
    siteStructureFilter: {
      itemTypeIdentifier: 'wix.blog.sub_pages.post',
      sourceId: '14bcded7-0066-7c35-14d7-466cb3f09103'
    },
    pageLimit: DEFAULT_PAGE_LIMIT,
    chunkSizeForNonAxeRules: 20
  },
  [ITEM_TYPES.EVENTS_PAGE]: {
    itemType: ITEM_TYPES.EVENTS_PAGE,
    appDefId: WIX_EVENTS,
    templatePageIntentId: 'events',
    siteStructureFilter: {
      itemTypeIdentifier: 'wix.events.sub_pages.event',
      sourceId: '140603ad-af8d-84a5-2c80-a0f60cb47351'
    },
    excludedPageIntentIds: ['Schedule'],
    pageLimit: DEFAULT_PAGE_LIMIT
  },
  [ITEM_TYPES.PORTFOLIO_PROJECTS]: {
    itemType: ITEM_TYPES.PORTFOLIO_PROJECTS,
    appDefId: WIX_PORTFOLIO,
    templatePageIntentId: 'Project',
    siteStructureFilter: {
      configId: 'portfolio-collections',
      itemTypeIdentifier: 'dynamic-page',
      pageIdentifier: 'project',
      sourceId: 'd90652a2-f5a1-4c7c-84c4-d4cdcc41f130'
    },
    queryRouterArgs: {
      prefix: 'portfolio-collections',
      routerPageKey: 'project'
    },
    pageLimit: DEFAULT_PAGE_LIMIT
  },
  [ITEM_TYPES.PORTFOLIO_COLLECTIONS]: {
    itemType: ITEM_TYPES.PORTFOLIO_COLLECTIONS,
    appDefId: WIX_PORTFOLIO,
    templatePageIntentId: 'Collection',
    siteStructureFilter: {
      configId: 'portfolio-collections',
      itemTypeIdentifier: 'dynamic-page',
      pageIdentifier: 'collection',
      sourceId: 'd90652a2-f5a1-4c7c-84c4-d4cdcc41f130'
    },
    queryRouterArgs: {
      prefix: 'portfolio-collections',
      routerPageKey: 'collection'
    },
    pageLimit: DEFAULT_PAGE_LIMIT
  },
  [ITEM_TYPES.GROUPS_PAGE]: {
    itemType: ITEM_TYPES.GROUPS_PAGE,
    appDefId: WIX_GROUPS,
    templatePageIntentId: 'group',
    siteStructureFilter: {
      itemTypeIdentifier: 'wix.groups.sub_pages.group',
      sourceId: '148c2287-c669-d849-d153-463c7486a694'
    },
    pageLimit: DEFAULT_PAGE_LIMIT
  },
  [ITEM_TYPES.CHALLENGES_PAGE]: {
    itemType: ITEM_TYPES.CHALLENGES_PAGE,
    appDefId: WIX_CHALLENGES,
    templatePageIntentId: 'challenge_page',
    siteStructureFilter: {
      itemTypeIdentifier: 'wix.online_programs.sub_pages.online_program',
      sourceId: '2936472a-a1ed-4ae5-9f71-614313a9f4e7'
    },
    excludedPageIntentIds: ['Challenge Payment', 'Participant Page', 'Thank You Page'],
    pageLimit: DEFAULT_PAGE_LIMIT
  },
  [ITEM_TYPES.RESTAURANTS_MENU_PAGE]: {
    itemType: ITEM_TYPES.RESTAURANTS_MENU_PAGE,
    appDefId: WIX_RESTAURANTS_MENUS_NEW,
    templatePageIntentId: 'Menus',
    siteStructureFilter: {
      itemTypeIdentifier: 'wix.restaurants.sub_pages.menu',
      sourceId: 'b278a256-2757-4f19-9313-c05c783bec92'
    },
    pageLimit: DEFAULT_PAGE_LIMIT
  },
  [ITEM_TYPES.PRICING_PLANS]: {
    itemType: ITEM_TYPES.PRICING_PLANS,
    appDefId: PRICING_PLANS,
    templatePageIntentId: 'membership_plan_picker_tpa',
    // Keep in sync with A11Y_RULES_EXPERIMENTS.ENABLE_PRICING_PLAN (@wix/a11y-rules).
    // Kept as a literal (like the other `enabledBy` specs) to avoid a runtime
    // import of a11y-rules into this client library.
    enabledBy: 'a11yEnablePricingPlan',
    siteStructureFilter: {
      itemTypeIdentifier: 'dynamic-page',
      sourceId: '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3',
      configId: 'pricing-plans',
      pageIdentifier: 'pricing_plans'
    },
    pageLimit: DEFAULT_PAGE_LIMIT
  },
  [ITEM_TYPES.TABLE_RESERVATIONS_EXPERIENCE]: {
    itemType: ITEM_TYPES.TABLE_RESERVATIONS_EXPERIENCE,
    appDefId: WIX_RESTAURANTS_TABLE_RESERVATIONS,
    templatePageIntentId: 'Experience Details',
    enabledBy: 'specs.a11y.enableTableReservationsExperience',
    siteStructureFilter: {
      itemTypeIdentifier: 'wix.table_reservations.sub_pages.experience',
      sourceId: 'f9c07de2-5341-40c6-b096-8eb39de391fb'
    },
    pageLimit: DEFAULT_PAGE_LIMIT
  }
};
const appDefIdToItemType = Object.fromEntries(Object.entries(itemTypeConfigMap).map(_ref => {
  let [itemType, config] = _ref;
  return [config.appDefId, itemType];
}));
const tpaPageIdToItemTypeConfig = Object.fromEntries(Object.entries(itemTypeConfigMap).flatMap(_ref2 => {
  let [_, config] = _ref2;
  return config.templatePageIntentId ? [[config.templatePageIntentId, config]] : [];
}));
export { itemTypeConfigMap, appDefIdToItemType, DEFAULT_PAGE_LIMIT, tpaPageIdToItemTypeConfig };
//# sourceMappingURL=item-type-config-map.js.map